import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09c3997c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "goods-list"
}

import GoodsOne from "@/components/order/postsale/GoodsOne.vue"
import GoodsMore from "@/components/order/postsale/GoodsMore.vue"
import GoodsPostSale from "@/components/order/postsale/GoodsPostSale.vue"
import { ref, watchEffect, withDefaults } from "vue"
import { OrderGoodsType } from "@/utils/apitype/goodsType"
import { postSaleType } from "@/utils/apitype/postSaleType"
interface Props {
  goodsList: Array<OrderGoodsType>
  status: number
  postSale: postSaleType | undefined
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PostSaleGoods',
  props: {
    goodsList: null,
    status: { default: 0 },
    postSale: { default: undefined }
  },
  setup(__props: any) {

const { goodsList, status, postSale } = __props as { goodsList: Array<OrderGoodsType>, status: number, postSale: postSaleType | undefined };



return (_ctx: any,_cache: any) => {
  return (goodsList.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (goodsList.length == 1)
          ? (_openBlock(), _createBlock(GoodsOne, {
              key: 0,
              goodsInfo: goodsList[0]
            }, null, 8, ["goodsInfo"]))
          : (_openBlock(), _createBlock(GoodsMore, {
              key: 1,
              goodsList: goodsList
            })),
        (status == 1)
          ? (_openBlock(), _createBlock(GoodsPostSale, {
              key: 2,
              postSale: postSale
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})